class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    const form = this.querySelector('form');
    form.addEventListener('input', (event) => {
      // Ignore price range inputs - they should only apply when Apply button is clicked
      if (event.target.closest('price-range')) {
        return;
      }
      this.debouncedOnSubmit(event);
    });
    form.addEventListener('change', (event) => {
      // Ignore price range inputs - they should only apply when Apply button is clicked
      if (event.target.closest('price-range')) {
        return;
      }
      this.debouncedOnSubmit(event);
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    
    if (!sections || sections.length === 0) {
      console.warn('No sections found for rendering');
      return;
    }
    
    const facetDrawer = document.getElementById('FacetDrawer');
    const countContainer = document.getElementById('ProductCount');
    const countContainerMobile = document.getElementById('ProductCountMobile');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collection = productGridContainer.querySelector('.collection');
      if (collection) {
        collection.classList.add('loading');
      }
    }
    if (countContainer){
      countContainer.classList.add('loading');
    }   
    if (countContainerMobile){
      countContainerMobile.classList.add('loading');
    } 
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }
    if (facetDrawer){
      facetDrawer.classList.add('loading');
    }

    sections.forEach((section) => {
      if (!section.section) {
        console.warn('Section ID is missing');
        return;
      }
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    
    document.dispatchEvent(new CustomEvent('collection:reloaded'));
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .catch((e) => {
        console.error('Error fetching filter data:', e);
        // Remove loading state on error
        const productGridContainer = document.getElementById('ProductGridContainer');
        if (productGridContainer) {
          const collection = productGridContainer.querySelector('.collection');
          if (collection) {
            collection.classList.remove('loading');
          }
        }
        const countContainer = document.getElementById('ProductCount');
        if (countContainer) {
          countContainer.classList.remove('loading');
        }
        const countContainerMobile = document.getElementById('ProductCountMobile');
        if (countContainerMobile) {
          countContainerMobile.classList.remove('loading');
        }
        const facetDrawer = document.getElementById('FacetDrawer');
        if (facetDrawer) {
          facetDrawer.classList.remove('loading');
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    
    const layoutSwitcher = document.querySelector('#FacetSortFiltersForm layout-switcher');
    if (layoutSwitcher) layoutSwitcher.onButtonClick(layoutSwitcher.querySelector('.list-view__item--active'));
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerMobile = document.getElementById('ProductCountMobile');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerMobile) {
      containerMobile.innerHTML = count;
      containerMobile.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetSortFiltersForm .js-filter, #FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => { 
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false; 
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const targetElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (targetElement) {
        // Preserve open/closed state
        const wasOpen = targetElement.hasAttribute('open');
        
        // Update summary separately to preserve open/closed state
        const targetSummary = targetElement.querySelector('summary.facets__header');
        const sourceSummary = element.querySelector('summary.facets__header');
        if (targetSummary && sourceSummary) {
          targetSummary.innerHTML = sourceSummary.innerHTML;
        }
        
        // Update content wrapper
        const targetContent = targetElement.querySelector('.filter-content-wrapper');
        const sourceContent = element.querySelector('.filter-content-wrapper');
        if (targetContent && sourceContent) {
          targetContent.innerHTML = sourceContent.innerHTML;
        } else {
          // Fallback: update everything except summary
          const summary = targetElement.querySelector('summary');
          if (summary) {
            const summaryHTML = summary.outerHTML;
            targetElement.innerHTML = element.innerHTML;
            // Restore summary and state
            const newSummary = targetElement.querySelector('summary');
            if (newSummary) {
              newSummary.innerHTML = summary.innerHTML;
            }
            if (wasOpen) {
              targetElement.setAttribute('open', '');
            }
          } else {
            targetElement.innerHTML = element.innerHTML;
          }
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    const facetDrawer = document.getElementById('FacetDrawer');
    if (facetDrawer) {
      facetDrawer.classList.remove('loading');
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.facets__open', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // Render active filter badges wrapper (desktop)
    const activeFiltersWrapper = html.querySelector('.facets__active-filters-wrapper');
    const currentActiveFiltersWrapper = document.querySelector('.facets__active-filters-wrapper');
    const facetsMain = document.querySelector('#FacetFiltersForm .facets__main');
    
    if (activeFiltersWrapper && currentActiveFiltersWrapper) {
      // Preserve open/closed state
      const wasOpen = currentActiveFiltersWrapper.hasAttribute('open');
      currentActiveFiltersWrapper.innerHTML = activeFiltersWrapper.innerHTML;
      if (wasOpen) {
        currentActiveFiltersWrapper.setAttribute('open', '');
      }
    } else if (activeFiltersWrapper && !currentActiveFiltersWrapper && facetsMain) {
      // Insert at the beginning of facets__main
      const wrapperElement = activeFiltersWrapper.cloneNode(true);
      facetsMain.insertBefore(wrapperElement, facetsMain.firstChild);
    } else if (!activeFiltersWrapper && currentActiveFiltersWrapper) {
      // Remove wrapper if no active filters
      currentActiveFiltersWrapper.remove();
    }

    // Render active filter badges wrapper (mobile)
    const mobileActiveFiltersWrapper = html.querySelector('.mobile-facets__active-filters-wrapper');
    const currentMobileActiveFiltersWrapper = document.querySelector('.mobile-facets__active-filters-wrapper');
    const mobileFacetsMain = document.querySelector('.mobile-facets__main');
    
    if (mobileActiveFiltersWrapper && currentMobileActiveFiltersWrapper) {
      // Preserve open/closed state
      const wasOpen = currentMobileActiveFiltersWrapper.hasAttribute('open');
      currentMobileActiveFiltersWrapper.innerHTML = mobileActiveFiltersWrapper.innerHTML;
      if (wasOpen) {
        currentMobileActiveFiltersWrapper.setAttribute('open', '');
      }
    } else if (mobileActiveFiltersWrapper && !currentMobileActiveFiltersWrapper && mobileFacetsMain) {
      // Insert at the beginning of mobile-facets__main
      const wrapperElement = mobileActiveFiltersWrapper.cloneNode(true);
      mobileFacetsMain.insertBefore(wrapperElement, mobileFacetsMain.firstChild);
    } else if (!mobileActiveFiltersWrapper && currentMobileActiveFiltersWrapper) {
      // Remove wrapper if no active filters
      currentMobileActiveFiltersWrapper.remove();
    }

    // Update filter count bubbles in headers
    const facetHeaders = document.querySelectorAll('.facets__header');
    facetHeaders.forEach((header) => {
      const filterIndex = header.closest('.js-filter')?.dataset.index;
      if (!filterIndex) return;
      
      const newHeader = html.querySelector(`.js-filter[data-index="${filterIndex}"] .facets__header`);
      if (newHeader) {
        const headerContent = header.querySelector('.facets__header-content');
        const newHeaderContent = newHeader.querySelector('.facets__header-content');
        if (headerContent && newHeaderContent) {
          headerContent.innerHTML = newHeaderContent.innerHTML;
        }
      }
    });

    const facetFiltersFormMobile = document.getElementById('FacetFiltersFormMobile');
    if (facetFiltersFormMobile && facetFiltersFormMobile.closest('facet-drawer')) {
      facetFiltersFormMobile.closest('facet-drawer').bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams(formData);
    
    // Remove price filter params if they are not explicitly set (empty or default values)
    // This prevents price filters from being applied when other filters change
    const priceRangeInputs = form.querySelectorAll('price-range input[name*="filter.v.price"]');
    priceRangeInputs.forEach(input => {
      const paramName = input.name;
      const value = input.value;
      
      // Get the price range component to check min/max defaults
      const priceRange = input.closest('price-range');
      if (priceRange) {
        const min = parseFloat(priceRange.dataset.min) || 0;
        const max = parseFloat(priceRange.dataset.max) || 0;
        
        // Check if this is a min value input
        if (paramName.includes('.gte') || paramName.includes('GTE')) {
          const minVal = parseFloat(value);
          // Remove if empty, 0, or NaN (default state) - values are in dollars
          if (!value || value === '' || isNaN(minVal) || minVal === 0 || minVal === min) {
            params.delete(paramName);
          }
        }
        // Check if this is a max value input
        else if (paramName.includes('.lte') || paramName.includes('LTE')) {
          const maxVal = parseFloat(value);
          // Remove if empty, NaN, or equals max (default state) - values are in dollars
          if (!value || value === '' || isNaN(maxVal) || maxVal === max) {
            params.delete(paramName);
          }
        }
      } else {
        // If no price range component found, remove if empty
        if (!value || value === '') {
          params.delete(paramName);
        }
      }
    });
    
    return params;
  }

  mergeSearchParams(form, searchParams) {
    const params = this.createSearchParams(form);
    params.forEach((value, key) => {
      // Don't add price filter params if they are default values
      if (key.includes('filter.v.price')) {
        const priceRange = form.querySelector('price-range');
        if (priceRange) {
          const min = parseFloat(priceRange.dataset.min) || 0;
          const max = parseFloat(priceRange.dataset.max) || 0;
          
          if (key.includes('.gte') || key.includes('GTE')) {
            const minVal = parseFloat(value);
            // Skip if default (0 or empty) - values are in dollars
            if (isNaN(minVal) || minVal === 0 || minVal === min) {
              return;
            }
          } else if (key.includes('.lte') || key.includes('LTE')) {
            const maxVal = parseFloat(value);
            // Skip if default (max or empty) - values are in dollars
            if (isNaN(maxVal) || maxVal === max) {
              return;
            }
          }
        }
      }
      searchParams.append(key, value);
    });
    return searchParams;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    // Get the form - try event.target first, then event.currentTarget, then find form directly
    let currentForm = null;
    if (event.target && event.target.closest) {
      currentForm = event.target.closest('form');
    } else if (event.currentTarget && event.currentTarget.closest) {
      currentForm = event.currentTarget.closest('form');
    } else if (event.target && event.target.tagName === 'FORM') {
      currentForm = event.target;
    } else if (event.currentTarget && event.currentTarget.tagName === 'FORM') {
      currentForm = event.currentTarget;
    }
    
    // If still no form found, try to find it from the facet-filters-form element
    if (!currentForm) {
      const facetFiltersForm = this.closest ? this : document.querySelector('facet-filters-form');
      if (facetFiltersForm) {
        currentForm = facetFiltersForm.querySelector('form');
      }
    }
    
    if (!currentForm) {
      console.warn('Could not find form for submission');
      return;
    }
    if (currentForm.id === 'FacetFiltersFormMobile') {
      const searchParams = this.createSearchParams(currentForm);
      this.onSubmitForm(searchParams.toString(), event);
    }
    else {
      let searchParams = new URLSearchParams();

      if (currentForm.id === 'FacetSortFiltersForm' && currentForm.dataset.filterType === 'drawer') {
        const mobileForm = document.getElementById('FacetFiltersFormMobile');
        searchParams = this.mergeSearchParams(mobileForm, searchParams);
        searchParams.delete('sort_by');
      }
  
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetFiltersForm' || form.id === 'FacetSortFiltersForm') {
          searchParams = this.mergeSearchParams(form, searchParams);
        }
      });

      this.onSubmitForm(searchParams.toString(), event);
    }
    /*
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
    */
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }

  static setupApplyButtons() {
    // Handle Apply buttons in facets drawer and mobile facets
    // Use a more specific approach to avoid duplicate listeners
    const applyButtonSelector = '.facets__footer button:not([data-listener-added]), .mobile-facets__footer button:not([data-listener-added])';
    
    document.querySelectorAll(applyButtonSelector).forEach(button => {
      // Mark button as having listener to prevent duplicates
      button.setAttribute('data-listener-added', 'true');
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find the form - try multiple ways
        const drawer = this.closest('facet-drawer') || this.closest('.mobile-facets__wrapper');
        let form = null;
        
        // First try to find form in the drawer
        if (drawer) {
          form = drawer.querySelector('form');
        }
        
        // If no form in drawer, try to find the main form
        if (!form) {
          // Try to find form from button's parent structure
          const buttonParent = this.closest('facet-filters-form') || this.closest('.facets__footer') || this.closest('.mobile-facets__footer');
          if (buttonParent) {
            form = buttonParent.querySelector('form');
          }
        }
        
        // If still no form, try by ID
        if (!form) {
          form = document.getElementById('FacetSortFiltersForm') || 
                 document.getElementById('FacetFiltersForm') || 
                 document.getElementById('FacetFiltersFormMobile');
        }
        
        if (form) {
          // Update price range inputs before submitting
          // This ensures the form has the latest values from the price range component
          const priceRanges = form.querySelectorAll('price-range');
          priceRanges.forEach(priceRange => {
            // Find visible inputs (these are the form inputs that will be submitted)
            const visibleMin = priceRange.querySelector('.price-range__input[id*="-GTE"]') || 
                              priceRange.querySelector('.field__input[id*="-GTE"]') ||
                              priceRange.querySelector('input[id*="-GTE"]:not([type="hidden"])');
            const visibleMax = priceRange.querySelector('.price-range__input[id*="-LTE"]') || 
                              priceRange.querySelector('.field__input[id*="-LTE"]') ||
                              priceRange.querySelector('input[id*="-LTE"]:not([type="hidden"])');
            
            const minDefault = parseFloat(priceRange.dataset.min) || 0;
            const maxDefault = parseFloat(priceRange.dataset.max) || 0;
            
            // Get current values - prefer input values, fallback to slider position
            let minVal = null;
            let maxVal = null;
            
            if (visibleMin && visibleMin.value) {
              minVal = parseFloat(visibleMin.value);
            } else {
              // Get from slider position (CSS variables)
              const currentLower = parseFloat(priceRange.style.getPropertyValue("--progress-lower")) || 0;
              const range = maxDefault - minDefault;
              minVal = (currentLower / 100) * range + minDefault;
            }
            
            if (visibleMax && visibleMax.value) {
              maxVal = parseFloat(visibleMax.value);
            } else {
              // Get from slider position (CSS variables)
              const currentUpper = parseFloat(priceRange.style.getPropertyValue("--progress-upper")) || 100;
              const range = maxDefault - minDefault;
              maxVal = (currentUpper / 100) * range + minDefault;
            }
            
            // Check if price filter is actually set (not default values)
            let hasPriceFilter = false;
            
            // Update min value
            if (visibleMin && !isNaN(minVal) && minVal > minDefault) {
              hasPriceFilter = true;
              // Shopify expects values in cents in the URL parameters
              // Convert dollars to cents and update the input
              const minValCents = Math.round(minVal * 100);
              visibleMin.value = minValCents;
            } else if (visibleMin) {
              // Remove min value if it's default
              visibleMin.value = '';
              visibleMin.removeAttribute('value');
            }
            
            // Update max value
            if (visibleMax && !isNaN(maxVal) && maxVal < maxDefault) {
              hasPriceFilter = true;
              // Shopify expects values in cents in the URL parameters
              // Convert dollars to cents and update the input
              const maxValCents = Math.round(maxVal * 100);
              visibleMax.value = maxValCents;
            } else if (visibleMax) {
              // Remove max value if it's default
              visibleMax.value = '';
              visibleMax.removeAttribute('value');
            }
            
            // If no price filter is set, ensure inputs are empty
            if (!hasPriceFilter) {
              if (visibleMin) {
                visibleMin.value = '';
                visibleMin.removeAttribute('value');
              }
              if (visibleMax) {
                visibleMax.value = '';
                visibleMax.removeAttribute('value');
              }
            }
          });
          
          // Submit the form using the facet-filters-form handler
          const facetFiltersForm = form.closest('facet-filters-form') || document.querySelector('facet-filters-form');
          if (!facetFiltersForm) {
            console.warn('Could not find facet-filters-form element');
            return;
          }
          
          if (!form) {
            console.warn('Could not find form element');
            return;
          }
          
          // Directly call the submission logic instead of using synthetic event
          // This is more reliable than creating a synthetic event
          let searchParams = new URLSearchParams();
          
          // Handle mobile form
          if (form.id === 'FacetFiltersFormMobile') {
            searchParams = facetFiltersForm.createSearchParams(form);
            const searchParamsString = searchParams.toString();
            facetFiltersForm.onSubmitForm(searchParamsString, null);
          } else {
            // Handle desktop form
            if (form.id === 'FacetSortFiltersForm' && form.dataset.filterType === 'drawer') {
              const mobileForm = document.getElementById('FacetFiltersFormMobile');
              if (mobileForm) {
                searchParams = facetFiltersForm.mergeSearchParams(mobileForm, searchParams);
                searchParams.delete('sort_by');
              }
            }
            
            // Merge all forms
            const sortFilterForms = document.querySelectorAll('facet-filters-form form');
            sortFilterForms.forEach((f) => {
              if (f.id === 'FacetFiltersForm' || f.id === 'FacetSortFiltersForm') {
                searchParams = facetFiltersForm.mergeSearchParams(f, searchParams);
              }
            });
            
            const searchParamsString = searchParams.toString();
            facetFiltersForm.onSubmitForm(searchParamsString, null);
          }
        }
        
        // Close the drawer after a small delay to allow form submission
        setTimeout(() => {
          const summary = drawer ? drawer.querySelector('summary') : null;
          if (summary) {
            summary.click();
          }
        }, 100);
      });
    });
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Setup Apply buttons after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    FacetFiltersForm.setupApplyButtons();
  });
} else {
  FacetFiltersForm.setupApplyButtons();
}

// Re-setup Apply buttons after collection reload
document.addEventListener('collection:reloaded', () => {
  FacetFiltersForm.setupApplyButtons();
});

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}
customElements.define('facet-remove', FacetRemove);

class PriceRange extends HTMLElement {
	constructor() {
    super();

    this.min = Number(this.dataset.min);
		this.max = Number(this.dataset.max);
    this.track = this.querySelector(".price-range__track");
		this.handles = [...this.querySelectorAll(".price-range__thumbs")];
		this.activeHandle;
		
		this.handles.forEach(handle => {
			handle.addEventListener("mousedown", this.startMove.bind(this));
			handle.addEventListener("touchstart", this.startMoveTouch.bind(this), { passive: false });
		})
		
		window.addEventListener("mouseup", this.stopMove.bind(this));
		window.addEventListener("touchend", this.stopMove.bind(this));
		window.addEventListener("touchcancel", this.stopMove.bind(this));

    this.querySelectorAll('.price-range__input').forEach(
      element => element.addEventListener('change', this.onRangeChange.bind(this))
    );
    
    // Initialize slider positions from input values
    this.initializeSliderPositions();
	}
	
	initializeSliderPositions() {
		// 1. Pronađi HIDDEN inpute (oni dolaze iz Shopify-a nakon učitavanja)
		const hiddenMin = this.querySelector('input[type="hidden"][id*="-GTE"]') ||
		                   this.querySelector('input[name*="filter.v.price.gte"]') ||
		                   this.querySelector('input[name*=".gte"]');
		const hiddenMax = this.querySelector('input[type="hidden"][id*="-LTE"]') ||
		                   this.querySelector('input[name*="filter.v.price.lte"]') ||
		                   this.querySelector('input[name*=".lte"]');
		
		// 2. Uzmi vrijednosti - Shopify sada očekuje dolare (ne cente)
		let minValue = this.min; // default u dolarima
		let maxValue = this.max; // default u dolarima
		
		if (hiddenMin && hiddenMin.value) {
			minValue = parseFloat(hiddenMin.value) || this.min;
		}
		if (hiddenMax && hiddenMax.value) {
			maxValue = parseFloat(hiddenMax.value) || this.max;
		}
		
		// 4. Postavi CSS varijable i atribute
		const range = this.max - this.min;
		const minPercentage = range > 0 ? ((minValue - this.min) / range) * 100 : 0;
		const maxPercentage = range > 0 ? ((maxValue - this.min) / range) * 100 : 100;
		
		this.style.setProperty("--progress-lower", `${Math.max(0, minPercentage)}%`);
		this.style.setProperty("--progress-upper", `${Math.min(100, maxPercentage)}%`);
		
		// Ažuriraj thumbs
		const lowerHandle = this.querySelector('.price-range__thumbs.is-lower');
		const upperHandle = this.querySelector('.price-range__thumbs.is-upper');
		if (lowerHandle) lowerHandle.setAttribute('aria-valuenow', minValue);
		if (upperHandle) upperHandle.setAttribute('aria-valuenow', maxValue);
		
		// Ažuriraj vidljive display vrijednosti ispod slidera
		const currency = this.querySelector('.price-range__input-currency')?.textContent || '';
		const displayMin = this.querySelector('.price-range__display-min');
		const displayMax = this.querySelector('.price-range__display-max');
		
		if (displayMin) displayMin.textContent = this.formatPrice(minValue, currency);
		if (displayMax) displayMax.textContent = this.formatPrice(maxValue, currency);
		
		// Set placeholders instead of values for inputs (mobile behavior)
		const visibleInputs = this.querySelectorAll('.price-range__input');
		if (visibleInputs[0]) {
			visibleInputs[0].value = '';
			visibleInputs[0].placeholder = minValue.toFixed(2);
		}
		if (visibleInputs[1]) {
			visibleInputs[1].value = '';
			visibleInputs[1].placeholder = maxValue.toFixed(2);
		}
	}

  onRangeChange(event) {
    // Mark input as user-edited
    event.currentTarget.dataset.userEdited = 'true';
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.updateOutputText(event.currentTarget);
    this.updateSliderFromInput(event.currentTarget);
    // Don't trigger form submission on input change - only on Apply button click
  }
  
  updateSliderFromInput(input) {
    const inputs = this.querySelectorAll('.price-range__input');
    const isLower = input === inputs[0];
    // Use value if present, otherwise use placeholder
    const value = Number(input.value) || Number(input.placeholder) || (isLower ? this.min : this.max);
    const percentage = (value - this.min) / (this.max - this.min);
    const property = isLower ? "--progress-lower" : "--progress-upper";
    
    // Update CSS variable
    this.style.setProperty(property, (percentage * 100) + "%");
    
    // Update handle position
    const handle = isLower ? this.querySelector('.price-range__thumbs.is-lower') : this.querySelector('.price-range__thumbs.is-upper');
    if (handle) {
      handle.setAttribute('aria-valuenow', value);
    }
    
    // Update output bubble
    const output = handle?.nextElementSibling;
    if (output && output.classList.contains('price-range__output')) {
      const text = output.querySelector('.price-range__output-text');
      if (text) {
        const currencySymbol = this.querySelector('.price-range__input-currency')?.textContent || '';
        const formattedValue = this.formatPrice(value, currencySymbol);
        text.textContent = formattedValue;
      }
    }
    
    // Update display text below slider
    const currencySymbol = this.querySelector('.price-range__input-currency')?.textContent || '';
    const formattedValue = this.formatPrice(value, currencySymbol);
    if (isLower) {
      const displayMin = this.querySelector('.price-range__display-min');
      if (displayMin) displayMin.textContent = formattedValue;
    } else {
      const displayMax = this.querySelector('.price-range__display-max');
      if (displayMax) displayMax.textContent = formattedValue;
    }
    
    // Update hidden inputs
    const hiddenMin = this.querySelector('input[type="hidden"][id*="-GTE"]') ||
                      this.querySelector('input[name*="filter.v.price.gte"]') ||
                      this.querySelector('input[name*=".gte"]');
    const hiddenMax = this.querySelector('input[type="hidden"][id*="-LTE"]') ||
                      this.querySelector('input[name*="filter.v.price.lte"]') ||
                      this.querySelector('input[name*=".lte"]');
    
    if (isLower && hiddenMin) {
      hiddenMin.value = Math.round(value);
    } else if (!isLower && hiddenMax) {
      hiddenMax.value = Math.round(value);
    }
  }

  updateOutputText(input) {
    const inputs = this.querySelectorAll('.price-range__input');
    const isLower = input === inputs[0];
    const handle = isLower ? this.querySelector('.price-range__thumbs.is-lower') : this.querySelector('.price-range__thumbs.is-upper');
    const output = handle?.nextElementSibling;
    if (output) {
      const text = output.querySelector('.price-range__output-text');
      const currencySymbol = this.querySelector('.price-range__input-currency')?.textContent || '';
      const value = Number(input.value);
      const formattedValue = this.formatPrice(value, currencySymbol);
      if (text) text.innerHTML = formattedValue;
    }
    
    // Update display text below slider
    const displayMin = this.querySelector('.price-range__display-min');
    const displayMax = this.querySelector('.price-range__display-max');
    if (isLower && displayMin) {
      displayMin.textContent = this.formatPrice(value, currencySymbol);
    } else if (!isLower && displayMax) {
      displayMax.textContent = this.formatPrice(value, currencySymbol);
    }
  }

  formatPrice(value, currencySymbol) {
    const num = Number(value);
    if (isNaN(num) || num < 0) return currencySymbol + '0.00';
    
    return currencySymbol + num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
	
	startMove(e) {
		e.preventDefault();
		this.activeHandle = e.target;
		this.moveListener = this.move.bind(this);
		window.addEventListener("mousemove", this.moveListener);
	}
	
	startMoveTouch(e) {
		e.preventDefault();
		this.activeHandle = e.target;
		this.moveListener = this.moveTouch.bind(this);
		window.addEventListener("touchmove", this.moveListener, { passive: false });
	}
	
	move(e) {
		e.preventDefault();
		const isLower = this.activeHandle.classList.contains("is-lower");
		const property = isLower ? "--progress-lower" : "--progress-upper";
		const parentRect = this.track.getBoundingClientRect();
		let newX = e.clientX - parentRect.x;
		
		this.updateHandlePosition(newX, isLower, property, parentRect);
	}
	
	moveTouch(e) {
		e.preventDefault();
		if (!e.touches || e.touches.length === 0) return;
		const isLower = this.activeHandle.classList.contains("is-lower");
		const property = isLower ? "--progress-lower" : "--progress-upper";
		const parentRect = this.track.getBoundingClientRect();
		let newX = e.touches[0].clientX - parentRect.x;
		
		this.updateHandlePosition(newX, isLower, property, parentRect);
	}
	
	updateHandlePosition(newX, isLower, property, parentRect) {
		// Get current progress values from the element's style
		const currentLower = parseFloat(this.style.getPropertyValue("--progress-lower")) || 0;
		const currentUpper = parseFloat(this.style.getPropertyValue("--progress-upper")) || 100;
		
    if (isLower) {
      const percentageX = (currentUpper / 100) * parentRect.width;
			newX = Math.min(newX, percentageX);
			newX = Math.max(newX, 0);
		}
    else {
      const percentageX = (currentLower / 100) * parentRect.width;
			newX = Math.max(newX, percentageX);
			newX = Math.min(newX, parentRect.width);
		}

    const percentage = Math.max(0, Math.min(1, newX / parentRect.width));
    const valuenow = this.calcHandleValue(percentage);
    
    // Update CSS variable on the price-range element
    this.style.setProperty(property, (percentage * 100) + "%");
		this.activeHandle.setAttribute('aria-valuenow', valuenow);

    // Update output bubble text
    const output = this.activeHandle.nextElementSibling;
    if (output && output.classList.contains('price-range__output')) {
      const text = output.querySelector('.price-range__output-text');
      if (text) {
        const currencySymbol = this.querySelector('.price-range__input-currency')?.textContent || '';
        const formattedValue = this.formatPrice(valuenow, currencySymbol);
        text.textContent = formattedValue;
      }
    }

    // Update display text below slider
    const currencySymbol = this.querySelector('.price-range__input-currency')?.textContent || '';
    const formattedValue = this.formatPrice(valuenow, currencySymbol);
    if (isLower) {
      const displayMin = this.querySelector('.price-range__display-min');
      if (displayMin) displayMin.textContent = formattedValue;
    } else {
      const displayMax = this.querySelector('.price-range__display-max');
      if (displayMax) displayMax.textContent = formattedValue;
    }

    // Update visible input fields and hidden inputs
    const inputs = this.querySelectorAll('.price-range__input');
    const input = isLower ? inputs[0] : inputs[1];
    const hiddenMin = this.querySelector('input[type="hidden"][id*="-GTE"]') ||
                      this.querySelector('input[name*="filter.v.price.gte"]') ||
                      this.querySelector('input[name*=".gte"]');
    const hiddenMax = this.querySelector('input[type="hidden"][id*="-LTE"]') ||
                      this.querySelector('input[name*="filter.v.price.lte"]') ||
                      this.querySelector('input[name*=".lte"]');
    
    if (input) {
      // Round to 2 decimal places to avoid floating point errors
      const roundedValue = Math.round(valuenow * 100) / 100;
      // Update placeholder instead of value to maintain placeholder behavior
      input.placeholder = roundedValue.toFixed(2);
      // Only set value if user has interacted with input
      if (!input.dataset.userEdited) {
        input.value = '';
      }
      this.adjustToValidValues(input);
      this.setMinAndMaxValues();
      
      // Update hidden input for the moved handle - use rounded value
      if (isLower && hiddenMin) {
        hiddenMin.value = Math.round(valuenow);
      } else if (!isLower && hiddenMax) {
        hiddenMax.value = Math.round(valuenow);
      }
      
      // Update apply button state during slider move
      this.updateApplyButtonState();
    }
	}
	
	calcHandleValue(percentage) {
		const value = percentage * (this.max - this.min) + this.min;
		// Round to 2 decimal places for currency values to avoid floating point errors
		return Math.round(value * 100) / 100;
	}
	
	stopMove() {
		if (this.moveListener) {
			window.removeEventListener("mousemove", this.moveListener);
			window.removeEventListener("touchmove", this.moveListener);
		}
    
    // Update hidden inputs with final values from CSS variables (most accurate)
    const hiddenMin = this.querySelector('input[type="hidden"][id*="-GTE"]') ||
                      this.querySelector('input[name*="filter.v.price.gte"]') ||
                      this.querySelector('input[name*=".gte"]');
    const hiddenMax = this.querySelector('input[type="hidden"][id*="-LTE"]') ||
                      this.querySelector('input[name*="filter.v.price.lte"]') ||
                      this.querySelector('input[name*=".lte"]');
    
    // Get current values from CSS variables
    const currentLower = parseFloat(this.style.getPropertyValue("--progress-lower")) || 0;
    const currentUpper = parseFloat(this.style.getPropertyValue("--progress-upper")) || 100;
    
    // Convert percentages back to dollar values
    const range = this.max - this.min;
    const minValue = (currentLower / 100) * range + this.min;
    const maxValue = (currentUpper / 100) * range + this.min;
    
    if (hiddenMin) {
      hiddenMin.value = Math.round(minValue);
    }
    
    if (hiddenMax) {
      hiddenMax.value = Math.round(maxValue);
    }
    
    this.activeHandle = null;
    this.moveListener = null;
    // Update apply button state after slider move
    this.updateApplyButtonState();
    // Don't trigger form submission on slider move - only on Apply button click
	}

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('.price-range__input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (minInput && maxInput) {
      if (maxInput.value) minInput.setAttribute('max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('min', 0);
      if (maxInput.value === '') minInput.setAttribute('max', minInput.getAttribute('max') || this.max);
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  updateApplyButtonState() {
    const applyButton = this.querySelector('[data-price-apply]');
    if (!applyButton) return;
    
    const inputs = this.querySelectorAll('.price-range__input');
    
    // Check if any input has value or if slider has been moved from default
    let isChanged = false;
    
    // Check if slider positions are different from default (0% and 100%)
    const lowerProgress = parseFloat(this.style.getPropertyValue('--progress-lower')) || 0;
    const upperProgress = parseFloat(this.style.getPropertyValue('--progress-upper')) || 100;
    
    if (lowerProgress > 0 || upperProgress < 100) {
      isChanged = true;
    }
    
    // Also check if user has edited inputs
    inputs.forEach(input => {
      if (input.dataset.userEdited && input.value && input.value.trim() !== '') {
        isChanged = true;
      }
    });
    
    // Toggle is-active class
    if (isChanged) {
      applyButton.classList.add('is-active');
    } else {
      applyButton.classList.remove('is-active');
    }
  }

  connectedCallback() {
    const applyButton = this.querySelector('[data-price-apply]');
    const resetButton = this.querySelector('[data-price-reset]');
    
    // Initialize button state
    this.updateApplyButtonState();
    
    // Add event listeners for input changes
    const inputs = this.querySelectorAll('.price-range__input');
    inputs.forEach(input => {
      // Mark as user-edited on focus if not already edited
      input.addEventListener('focus', () => {
        if (!input.dataset.userEdited && !input.value) {
          // Keep placeholder visible, don't clear it
          input.placeholder = input.placeholder || (input.id.includes('GTE') ? '0' : this.max.toString());
        }
      });
      input.addEventListener('input', () => {
        input.dataset.userEdited = 'true';
        this.updateApplyButtonState();
      });
      input.addEventListener('change', () => {
        input.dataset.userEdited = 'true';
        this.updateApplyButtonState();
      });
    });
    
    // Add event listeners for slider changes
    const thumbs = this.querySelectorAll('.price-range__thumbs');
    thumbs.forEach(thumb => {
      thumb.addEventListener('mousedown', () => {
        this.updateApplyButtonState();
      });
      thumb.addEventListener('touchstart', () => {
        this.updateApplyButtonState();
      });
    });
    
    // Reset button functionality
    if (resetButton) {
      resetButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Reset inputs to empty and clear user-edited flag
        inputs.forEach(input => {
          input.value = '';
          input.placeholder = input.id.includes('GTE') ? '0' : this.max.toString();
          delete input.dataset.userEdited;
        });
        
        // Reset hidden inputs
        const hiddenMin = this.querySelector('input[type="hidden"][id*="-GTE"]');
        const hiddenMax = this.querySelector('input[type="hidden"][id*="-LTE"]');
        if (hiddenMin) hiddenMin.value = '0';
        if (hiddenMax) hiddenMax.value = this.max.toString();
        
        // Reset slider positions
        this.style.setProperty('--progress-lower', '0%');
        this.style.setProperty('--progress-upper', '100%');
        
        // Update display values
        const currencySymbol = this.querySelector('.price-range__input-currency')?.textContent || '';
        const displayMin = this.querySelector('.price-range__display-min');
        const displayMax = this.querySelector('.price-range__display-max');
        if (displayMin) displayMin.textContent = this.formatPrice(0, currencySymbol);
        if (displayMax) displayMax.textContent = this.formatPrice(this.max, currencySymbol);
        
        // Update thumbs
        const lowerThumb = this.querySelector('.price-range__thumbs.is-lower');
        const upperThumb = this.querySelector('.price-range__thumbs.is-upper');
        if (lowerThumb) lowerThumb.setAttribute('aria-valuenow', '0');
        if (upperThumb) upperThumb.setAttribute('aria-valuenow', this.max.toString());
        
        this.updateApplyButtonState();
        
        // Hide reset button after reset
        resetButton.style.display = 'none';
        
        // Trigger form submission to apply reset
        const form = this.closest('form');
        if (form) {
          const facetFiltersForm = form.closest('facet-filters-form');
          if (facetFiltersForm) {
            facetFiltersForm.onSubmitHandler(new Event('submit', { bubbles: true }));
          }
        }
      });
    }
    
    if (applyButton) {
      applyButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const visibleMin = this.querySelector('.price-range__input[id*="-GTE-input"]');
        const visibleMax = this.querySelector('.price-range__input[id*="-LTE-input"]');
        
        // Use value if present, otherwise use placeholder
        let minVal = visibleMin ? (parseFloat(visibleMin.value) || parseFloat(visibleMin.placeholder) || 0) : 0;
        let maxVal = visibleMax ? (parseFloat(visibleMax.value) || parseFloat(visibleMax.placeholder) || this.max) : this.max;
        
        // Spreči nelogične vrijednosti
        if (isNaN(minVal)) minVal = 0;
        if (isNaN(maxVal)) maxVal = this.max;
        minVal = Math.max(0, minVal);
        maxVal = Math.min(this.max, maxVal);
        
        // Update HIDDEN polja – Shopify očekuje dolare (ne cente)!
        const hiddenMin = this.querySelector('input[type="hidden"][id*="-GTE"]') ||
                          this.querySelector('input[name*="filter.v.price.gte"]') ||
                          this.querySelector('input[name*=".gte"]');
        const hiddenMax = this.querySelector('input[type="hidden"][id*="-LTE"]') ||
                          this.querySelector('input[name*="filter.v.price.lte"]') ||
                          this.querySelector('input[name*=".lte"]');
        
        // Hidden inputs store dollars (matching template format), Shopify URL expects dollars
        if (hiddenMin) hiddenMin.value = Math.round(minVal);
        if (hiddenMax) hiddenMax.value = Math.round(maxVal);
        
        // Remove is-active class after applying
        applyButton.classList.remove('is-active');
        
        // Trigger form submission only when Apply button is clicked
        const form = this.closest('form');
        if (form) {
          const facetFiltersForm = form.closest('facet-filters-form');
          if (facetFiltersForm) {
            if (form.id === 'FacetFiltersFormMobile') {
              const searchParams = facetFiltersForm.createSearchParams(form);
              facetFiltersForm.onSubmitForm(searchParams.toString(), null);
            } else {
              let searchParams = new URLSearchParams();
              if (form.id === 'FacetSortFiltersForm' && form.dataset.filterType === 'drawer') {
                const mobileForm = document.getElementById('FacetFiltersFormMobile');
                if (mobileForm) {
                  searchParams = facetFiltersForm.mergeSearchParams(mobileForm, searchParams);
                  searchParams.delete('sort_by');
                }
              }
              const sortFilterForms = document.querySelectorAll('facet-filters-form form');
              sortFilterForms.forEach((f) => {
                if (f.id === 'FacetFiltersForm' || f.id === 'FacetSortFiltersForm') {
                  searchParams = facetFiltersForm.mergeSearchParams(f, searchParams);
                }
              });
              facetFiltersForm.onSubmitForm(searchParams.toString(), null);
            }
          }
        }
      });
    }
    
    // VAŽNO: Nakon svakog reload-a (AJAX) ponovno inicijaliziraj
    document.addEventListener('collection:reloaded', () => {
      this.initializeSliderPositions();
    }, { once: false });
  }
}
customElements.define('price-range', PriceRange);

class LayoutSwitcher extends HTMLElement {
	constructor() {
    super();

    this.cookieName = 'beyours:collection-layout';

    this.initLayoutMode();
    this.querySelectorAll('.list-view__item').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
	}
	
  onButtonClick(event) {
    const target = event.target ? event.target : event;
    this.changeLayoutMode(target, target.dataset.layoutMode);
  }

  initLayoutMode() {
    if (isStorageSupported('local')) {
      const layoutMode = window.localStorage.getItem(this.cookieName);

      if (layoutMode !== null) {
        const target = this.querySelector(`.list-view__item[data-layout-mode="${layoutMode}"]`);

        if (target) {
          this.changeLayoutMode(target, layoutMode);
        }
      }
    }
  }

  changeLayoutMode(target, layoutMode) {
    const productGrid = document.getElementById('product-grid');

    if (productGrid.classList.contains('collection--empty')) {
      return;
    }

    const removedClass = ['list', 'grid', 'grid--1-col', 'grid--2-col', 'grid--3-col-tablet', 'grid--2-col-desktop', 'grid--3-col-desktop', 'grid--4-col-desktop'];
    removedClass.forEach((removed) => {
      productGrid.classList.remove(removed);
    });

    let addedClass = [];
    switch (layoutMode) {
      case 'list':
        addedClass = ['grid', 'grid--1-col', 'grid--2-col-desktop', 'list'];
        break;

      case 'grid-2':
        addedClass = ['grid', 'grid--2-col'];
        break;

      case 'grid-3':
        addedClass = ['grid', 'grid--2-col', 'grid--3-col-tablet', 'grid--3-col-desktop'];
        break;

      case 'grid-4':
        addedClass = ['grid', 'grid--2-col', 'grid--3-col-tablet', 'grid--4-col-desktop'];
        break;
    }
    addedClass.forEach((added) => {
      productGrid.classList.add(added);
    });

    this.querySelectorAll('.list-view__item').forEach(
      (button) => button.classList.remove('list-view__item--active')
    );

    target.classList.add('list-view__item--active');

    if (isStorageSupported('local')) {
      window.localStorage.setItem(this.cookieName, layoutMode);
    }
  }
}
customElements.define('layout-switcher', LayoutSwitcher);

class StickyFacetFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.parentNode.offsetTop) {
      window.requestAnimationFrame(this.reveal.bind(this));
    } else {
      window.requestAnimationFrame(this.reset.bind(this));
    }
  }

  reveal() {
    this.classList.add('shopify-section-filters-sticky');
  }

  reset() {
    this.classList.remove('shopify-section-filters-sticky');
  }
}
customElements.define('sticky-facet-filters', StickyFacetFilters);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();

    const attributes = {
      expanded: 'aria-expanded'
    };

    const button = this.querySelector('.button-show-more');
    if (button) {
      button.addEventListener('click', () => {
        const filter = this.closest('.js-filter');
        const isExpanded = filter.getAttribute(attributes.expanded) === 'true';
        filter.setAttribute(attributes.expanded, (!isExpanded).toString());
        button.setAttribute('aria-expanded', (!isExpanded).toString());

        // Toggle show more/less text
        const showMoreText = button.querySelector('.show-more-text');
        const showLessText = button.querySelector('.show-less-text');
        if (showMoreText && showLessText) {
          if (isExpanded) {
            showMoreText.style.display = '';
            showLessText.style.display = 'none';
          } else {
            showMoreText.style.display = 'none';
            showLessText.style.display = '';
          }
        }

      });
    }
  }
}
customElements.define('show-more-button', ShowMoreButton);

// Sort dropdown handler - close dropdown and update display value when option is selected
(function() {
  // Store event listener references to prevent duplicates
  const listenerMap = new WeakMap();
  
  function initSortDropdown() {
    document.querySelectorAll('.facet-filters__sort').forEach(sortDropdown => {
      // Remove existing listeners if any
      if (listenerMap.has(sortDropdown)) {
        const { items, handlers } = listenerMap.get(sortDropdown);
        items.forEach((item, index) => {
          item.removeEventListener('click', handlers[index]);
        });
      }
      
      const details = sortDropdown.querySelector('details');
      const summaryValue = sortDropdown.querySelector('.facets__summary-value');
      const items = Array.from(sortDropdown.querySelectorAll('.facets__item'));
      const handlers = [];
      
      items.forEach(item => {
        const handler = function(e) {
          const input = this.querySelector('input[type="radio"]');
          const label = this.querySelector('.label');
          
          if (input && !input.checked) {
            input.checked = true;
            
            // Trigger change event for form submission
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          
          // Update the display value
          if (summaryValue && label) {
            summaryValue.textContent = label.textContent;
          }
          
          // Close the dropdown after a small delay
          setTimeout(() => {
            if (details) {
              details.removeAttribute('open');
            }
          }, 100);
        };
        
        handlers.push(handler);
        item.addEventListener('click', handler);
      });
      
      // Store references for cleanup
      listenerMap.set(sortDropdown, { items, handlers });
    });
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortDropdown);
  } else {
    initSortDropdown();
  }
  
  // Re-initialize after collection reload (AJAX filtering)
  document.addEventListener('collection:reloaded', initSortDropdown);
})();

